let $hyoo_sync_revision = "echo"